// extracted by mini-css-extract-plugin
module.exports = {"lbp-detail-chart":"LBPChart_lbp-detail-chart__3ob5n","history-swap-chart":"LBPChart_history-swap-chart__3CPWx"};